var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labels-action"},[_c('create-new-label',{attrs:{"is-open":_vm.isLabelModalOpen,"init-name":_vm.initLabelName,"create-label":_vm.createNewLabel},on:{"update:isOpen":function($event){_vm.isLabelModalOpen=$event},"update:is-open":function($event){_vm.isLabelModalOpen=$event},"set-label":_vm.onCreate}}),_c('select-input',{key:_vm.chipsTemplate,attrs:{"setup":{
      'func': _vm.setLabel,
      'args': {
        'model': _vm.proxyAction.action,
        'key': 'label_index',
        'options': _vm.labelOptions,
        'multiple': true,
        'taggable': true,
        'notFoundOptionText': _vm.$t('labels_not_found').toString(),
        'prefix': ((_vm.snakeCase(_vm.proxyAction.action.type)) + "_"),
        'createButton': {
          'title': _vm.$t('create_label').toString(),
          'callback': _vm.prepareCreateNewLabel
        },
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }